// extracted by mini-css-extract-plugin
module.exports = {"proceedCheckoutButton":"CheckoutButton_proceedCheckoutButton__hoVLr","proceedCheckoutButtonText":"CheckoutButton_proceedCheckoutButtonText__O_nni"};